document.addEventListener('turbo:load', () => {
  const TIME_OUT = 3000
  const TRANSITION_TIME = 400

  document.querySelectorAll('.js-message-box .message-box').forEach((messageBox) => {
    const hide = () => {
      if (!messageBox.isConnected || messageBox.dataset.hiding === 'true') return

      messageBox.dataset.hiding = 'true'
      messageBox.classList.add('message-box-leave-active', 'message-box-leave-to')
      window.setTimeout(() => messageBox.remove(), TRANSITION_TIME)
    }

    messageBox.querySelector('.close')?.addEventListener('click', hide)
    window.setTimeout(hide, TIME_OUT)
  })
})
